export enum BuyBoxType {
  AboveTheFold = 'AboveTheFold',
  BuyBoxBottomSheetShort = 'BuyBoxBottomSheetShort',
  BuyBoxBottomSheetExpanded = 'BuyBoxBottomSheetExpanded',
  BuyBoxBottomSheetAlwaysExpanded = 'BuyBoxBottomSheetAlwaysExpanded',
  BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop = 'BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop',
}
